import { render, staticRenderFns } from "./SourceRequestDetail.vue?vue&type=template&id=4849de85&scoped=true&"
import script from "./SourceRequestDetail.vue?vue&type=script&lang=js&"
export * from "./SourceRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./SourceRequestDetail.vue?vue&type=style&index=0&id=4849de85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4849de85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardText,VDataTable})
